import React from 'react';
import ImageZoom from 'react-medium-image-zoom';
import coverImg from '../../imgs/SI/coverImg2.jpg';
import auditImg from '../../imgs/SI/siteAudit.jpg';
import researchImg from '../../imgs/SI/research.jpg';
import siteMapImg1 from '../../imgs/SI/siteMap1.jpg';
import siteMapImg2 from '../../imgs/SI/siteMap2.jpg';
import homePageImg from '../../imgs/SI/homepage.png';
import platformImg from '../../imgs/SI/platform.png';
import canvasImg from '../../imgs/SI/canvas.png';

const SI = () => (
  <div className="caseBody">
    <section className="head">
      <h2>Scaled Inference Website Redesign</h2>
      <p className="caseIntro">Scaled Inference</p>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Project Overview</h3>
      </div>
      <div className="right">
        <h4>CHALLENGE</h4>
        <p className="content-p">
          Introducing a new concept can be complicated and persuading visitors
          to try out our product also poses challenge. Our previous website
          depicted a future where AI be used by all but lack of details to
          explain how we’re going to achieve. How to help visitors understand
          Scaled Inference’s differentiated role and position and communicate it
          through the website is our major challenge.
        </p>
        <h4 id="myRoles">MY ROLE</h4>
        <p className="content-p">
          Product Designer - Research, competitive analysis, wireframes, visual
          design.
        </p>
        <h4>HIGHLIGHTS</h4>
        <p className="content-p p-check">
          I dug into research and analyzed how some other companies organized
          their website.
        </p>
        <p className="content-p p-check">
          I conducted several informal interviews with stakeholders and had a
          better understanding on how to develop content of individual page on
          the site.
        </p>
        <p className="content-p p-check">
          After finishing the site audit of existing website and taking a deeper
          dive into competitors, I sketched and proposed several iterations on
          how to present our product and story.
        </p>
        <h4>TOOLS</h4>
        <p className="content-p">Figma, Sketch</p>
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="process">Research Process</h3>
      </div>
      <div className="right">
        <h4>SITE AUDIT</h4>
        <p className="content-p">
          It was important to look into our existing website and figure out what
          we were missing. From my perspective, it was an incomplete, more like
          a “coming soon” site, which indicated what we weren’t readying to
          accept customers yet.
        </p>
        <p className="content-p">
          Through initial stage of exploration, I found that we didn’t even
          introduce our product - Amp.ai on the website. We had a pretty
          professional image but it was far from enough to keep visitors and
          persuade them to give it a try.
        </p>
        <ImageZoom
          image={{
            src: auditImg,
            alt: 'site audit',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>COMPETITIVE AUDIT</h4>
        <p className="content-p">
          The company always compares ourselves to A/B testing optimization
          platforms. Strictly speaking, we’re not the same but we have similar
          potential customers. I investigated multiple competitors within the
          similar line of business including optimizely, mixpanel and sentient.
        </p>
        <p className="content-p">
          I also drew inspiration from other product websites which have
          brilliant ways of demonstrating products.
        </p>
        <ImageZoom
          image={{
            src: researchImg,
            alt: 'research',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>STAKEHOLDER INTERVIEW</h4>
        <p className="content-p">
          I communicated with stakeholders inside the company including
          executive management team and marketing team. The interview probed at
          having a better understanding of our target audience, pain points, key
          message and important features of our product.
        </p>
        <p className="content-p">
          I was also able to talk informally with some interview candidates
          about how they thought of our website. Not surprisingly, almost
          everyone failed to figure out what we were doing based on the website.
          More information came from talking with one of us.
        </p>
        <h4>WHAT WE FOUND</h4>
        <p className="content-p">
          Visitors find it difficult to understand our product. There’s a lack
          of credibility and lack of motivation for them to try our product.
        </p>
        <p className="content-p">
          So let’s use the site to tell visitor a compelling story. The homepage
          will be a general introduction about Amp.ai, following some
          illustrations on different use cases. Next section is real customers,
          results and testimonials and CTA. A separate page provided more
          details on the platform. We set our target audience to developers.
          Everything about us and careers will be less significant.
        </p>
      </div>
    </section>
    <section className="mainSec">
      <div className="left">
        <h3 id="siteMap">Sitemap</h3>
      </div>
      <div className="right">
        <p className="content-p">
          It was difficult to demonstrate the whole product with the old website
          skeleton. Everything was nested. The new sitemap provides a more
          personalized approach for various kinds of users. Although currently
          we’re focusing on developers as the main user group, everyone else can
          get a general idea of how the platform works and how to use it.
        </p>
        <ImageZoom
          image={{
            src: siteMapImg1,
            alt: 'old sitemap',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: siteMapImg2,
            alt: 'new sitemap',
            className: 'img-responsive img-centered'
          }}
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="wireframes">Wireframes</h3>
      </div>
      <div className="right">
        <p className="content-p">
          We had a short-term solution to add a product section and a whole
          website update in the following month. Through the lens of this
          project, we found what went missing and add sections to help visitors
          understand the product.
        </p>
        <ImageZoom
          image={{
            src: homePageImg,
            alt: 'home page',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: platformImg,
            alt: 'platform',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: canvasImg,
            alt: 'canvas',
            className: 'img-responsive img-centered'
          }}
        />
        <a
          className="demo-link"
          href="https://scaledinference.com"
          rel="noopenner noreferrer"
          target="_blank"
        >
          SEE IT LIVE →
        </a>
      </div>
    </section>
  </div>
);

export default SI;



// WEBPACK FOOTER //
// ./src/Modules/Case/SI.js